window.jQuery = require('jquery');
window.$ = require('jquery');
var processInclude = require('@interceramic_js/util');

$(document).ready(function () {
    processInclude(require('base/components/menu'));
    processInclude(require('@interceramic_js/components/header'));
    processInclude(require('base/components/cookie'));
    processInclude(require('@interceramic_js/components/consentTracking'));
    processInclude(require('base/components/footer'));
    processInclude(require('@interceramic_js/components/miniCart'));
    processInclude(require('base/components/collapsibleItem'));
    processInclude(require('@interceramic_js/components/search'));
    processInclude(require('@interceramic_js/components/clientSideValidation'));
    processInclude(require('base/components/countrySelector'));
    processInclude(require('base/components/toolTip'));
    processInclude(require('@interceramic_js/product/wishlistHeart'));
    processInclude(require('@interceramic_js/product/wishlist'));
    processInclude(require('@interceramic_js/account/account'));
    processInclude(require('@interceramic_js/components/quote'));
    processInclude(require('@interceramic_js/compare'));
    processInclude(require('@interceramic_js/swatches'));
    processInclude(require('@interceramic_js/components/carousel'));
    processInclude(require('@interceramic_js/chatbot'));
    processInclude(require('@interceramic_js/login'));
});

require('base/thirdParty/bootstrap');
require('./components/spinner');
